<div>
    <div>
        <div class="mb-16">
            <span class="font-size-16"><b>{{"COLUMNS_ORDER_CONFIG.TITLE" | translate}}</b></span>
            <br>
            <span class="font-size-12">{{"COLUMNS_ORDER_CONFIG.DESCRIPTION" | translate}}</span>
        </div>
        <div cdkDropListGroup>
            <div class="columns-container">
          
              <div
                cdkDropList
                [cdkDropListData]="columns"
                class="columns-list"
                (cdkDropListDropped)="drop($event)">
                <div class="columns-box" *ngFor="let column of columns" cdkDrag>
                    <ng-container [ngSwitch]="moduleId">
                        <span *ngSwitchCase="MODULES.Alerts">
                            {{"ALERTS.FIELDS." + column | translate}}
                        </span>
                    </ng-container>
                </div>
              </div>
            </div>
    </div>

    <div fxLayout="row wrap" style="display: flex; justify-content: space-between;">
        <div class="m-8">
            <button mat-raised-button color="secondary" (click)="onSetDefaultConfig()">
                <span class="m-8">{{'COLUMNS_ORDER_CONFIG.SET_DEFAULT_CONFIG' | translate}}</span>
            </button>
        </div>
        <div class="m-8">
            <button mat-raised-button color="primary" (click)="onCancel()">
                <span class="m-8">{{'DIALOGS.ACTIONS.CANCEL' | translate}}</span>
            </button>
            <button mat-raised-button color="accent" class="ml-8" (click)="onConfirm()">
                <span class="m-8">{{'DIALOGS.ACTIONS.ACCEPT' | translate}}</span>
            </button>
        </div>
    </div>
</div>
